import React from 'react';

import { TextBox } from '@progress/kendo-react-inputs';
import { FloatingLabel } from '@progress/kendo-react-labels';

import clsx from 'clsx';

import * as classes from './BobInputField.module.css';

const BobInputField = ({
    className,
    rounded,
    fillMode,
    id,
    name,
    label,
    onChange,
    onBlur,
    errors,
    touched,
    size,
    value,
    ...props
}) => {

    return (
        <FloatingLabel
            className={errors ? classes.ErrorLabel : null}
            style={{fontSize: '1.2rem'}}
            label={label}
            editorId={id}
            editorValue={value}
        >
            <TextBox
                style={{ width: 240 }}
                className={errors ? clsx(classes.Error, className) : clsx(classes.Input, className)}
                fillMode={fillMode}
                id={id}
                rounded={rounded}
                size={size}
                value={value}
                onBlur={(event) => onBlur(event, name)}
                onChange={(event) => onChange(event, name)}
                name={name}
            />
        </FloatingLabel>
    );
};

export default BobInputField;
